var $ = require('jquery'); 
var isMobile = false; //initiate as false
mobileOnlySlider(".mobSlider", true, false, 767);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
		dots: $dots,
		arrows: $arrows,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '90px',
     cssEase: 'ease',
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};

	slider.slick(settings);
	
	$(window).on("load", function () {
		
		if ($(window).width() > $breakpoint) {
		return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
		if ($(window).width() < 767){
			$('ul.nav-tabs li').click(function () {
				$('.mobSlider').slick('refresh');
			});
		}
		
	});
	
	$(window).resize(function(){
	mobileOnlySlider($slidername, $dots, $arrows, $breakpoint);	
			});

} // Mobile Only Slider


